export default {
  seasonFrom: 'playerFilters.seasonFromLabel',
  seasonTo: 'playerFilters.seasonToLabel',
  gameType: 'playerFilters.gameTypeLabel',
  selectedDatesRange: 'playerFilters.datesRangeLabel',
  batHandedness: 'playerFilters.batHandednessLabel',
  throwHandedness: 'playerFilters.throwHandednessLabel',
};
